export const COLOR_GREY_600 = '#343B42';
export const COLOR_GREY_500 = '#71767B';
export const COLOR_GREY_400 = '#AEB1B5';
export const COLOR_GREY_300 = '#D8DADC';
export const COLOR_GREY_200 = '#EBEDEF';
export const COLOR_GREY_100 = '#F5F6F7';
export const COLOR_BLACK = COLOR_GREY_600;
export const COLOR_WHITE = '#FFFFFF';
export const COLOR_BLUE_200 = '#006aff';
export const COLOR_BLUE_100 = '#E5F2F9';
export const COLOR_RED_200 = '#D92B2B';
export const COLOR_RED_100 = '#FBEAEA';
export const COLOR_ORANGE_200 = '#FF7733';
export const COLOR_ORANGE_100 = '#FFDDCC';
export const COLOR_GOLD_200 = '#FFDD32';
export const COLOR_GOLD_100 = '#FFF1AD';
export const COLOR_GREEN_200 = '#26B223';
export const COLOR_GREEN_100 = '#E5F6E5';
export const COLOR_ACCENT_BROWN = '#693F1B';
export const COLOR_ACCENT_ORANGE = '#FF742E';
export const COLOR_ACCENT_GOLD = '#FFCC32';
export const COLOR_ACCENT_LIME = '#79C720';
export const COLOR_ACCENT_FOREST = '#117F00';
export const COLOR_ACCENT_TEAL = '#13BEBB';
export const COLOR_ACCENT_CYAN = '#148FCC';
export const COLOR_ACCENT_ROYAL = '#153FA3';
export const COLOR_ACCENT_INDIGO = '#8876ED';
export const COLOR_ACCENT_PURPLE = '#54298C';
export const COLOR_ACCENT_PLUM = '#A33C96';
export const COLOR_ACCENT_PINK = '#F26197';
export const COLOR_ACCENT_MAROON = '#AB0000';
export const COLOR_DEBUG = '#FF00CB';